import { Textarea as MantineTextarea } from '@mantine/core';
import type { TextareaProps as MantineTextareaProps } from '@mantine/core';
import './Textarea.css';

export interface TextareaProps extends MantineTextareaProps {
    error?: string;
}

export default function Textarea({
    error,
    className = '',
    ...props
}: TextareaProps) {
    return (
        <MantineTextarea
            className={`custom-textarea ${className}`.trim()}
            error={error}
            {...props}
        />
    );
}

